import React from 'react';

const TitleHeader = () => (
<div className='titleHeader'>
    <h1>Ed-FI: API KEY and Secret</h1>
</div>


);

export default TitleHeader;